import axios from "axios";
import { useEffect, useState } from "react";
import { getOpenApiInstance } from "./helper";

interface Church {
    name: string;
    id: string;
    church_id: string;
    country_code: string;
}

interface Profile {
    mygms_id: string;
    nij: string;
    name: string;
    church?: Church;
}

export default function useProfile(locationSearch: string, disableFetch: boolean = false) {
    const params = new URLSearchParams(locationSearch);
    const authCode = params.get("code") || params.get("auth_code");
    const [profile, setProfile] = useState<Profile | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (authCode && !disableFetch) {
            const fetchProfile = async () => {
                try {
                    const { instance } = getOpenApiInstance(authCode);
                    const response = await instance.get(`/accounts/me`).then(res => res.data);
                    setProfile(response.result);
                    setIsLoading(false);
                } catch (error) {
                    setError("Terjadi kesalahan! Silahkan coba beberapa saat lagi");
                    setIsLoading(false);
                };
            }
            fetchProfile();
        } else {
            setIsLoading(false)
        }
    }, [authCode]);

    return { profile, isLoading, error };
}